/*
  ODE – „Neu bei ODE“ (15.10.2026, fünfte Fassung).
  Auftritt: Grapefruit (oder Blatt) und die drei Zahlen gleiten nacheinander herein und blenden auf.
  Plakat im Stil der ODE-Motive von Stefan: Grün, dunkelgrünes Blatt (oder Grapefruit mit Blatt),
  riesiger Countdown in Rosa (Tage, Stunden, Minuten). Gezeichnet in ein 2D-Canvas, kein WebGL.
  Das Blatt wiegt sich ganz leicht; bei „Bewegung reduzieren“ (oder ode-ruhe) steht es still.
  data-motiv: "blatt" (nur Blatt) oder "frucht" (Grapefruit mit Blatt). data-modus: "seite" oder "band".
  Ohne Canvas bleibt der HTML-Countdown sichtbar; er ist auch role=timer für Screenreader.
*/
(function () {
  if (window.__odeNeu) return; window.__odeNeu = true;

  var GRUEN = '#007D41', BLATT = '#004D23', FRUCHT = '#EDAEBF', ROSA = '#FAD9DE';

  function ruhig() {
    return document.documentElement.classList.contains('ode-ruhe') || matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  /* Zielzeitpunkt in Berliner Zeit */
  function berlin(datum, zeit) {
    var d = (datum || '').split('-').map(Number), z = (zeit || '00:00').split(':').map(Number);
    if (d.length < 3 || !d[0]) return NaN;
    var guess = Date.UTC(d[0], d[1] - 1, d[2], z[0] || 0, z[1] || 0), p = {};
    try {
      new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Berlin', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })
        .formatToParts(new Date(guess)).forEach(function (x) { p[x.type] = x.value; });
      var alsUtc = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute);
      return guess - (alsUtc - guess);
    } catch (e) { return guess - 3600000; }
  }
  function rest(ziel) {
    var s = Math.floor(Math.max(0, ziel - Date.now()) / 1000);
    return { t: Math.floor(s / 86400), h: Math.floor(s % 86400 / 3600), m: Math.floor(s % 3600 / 60) };
  }
  var zw = function (n) { return (n < 10 ? '0' : '') + n; };

  /* Ein Blatt: Ansatz (x, y), Richtung, Länge, Breite */
  function blatt(c, x, y, wink, len, breit) {
    var ux = Math.cos(wink), uy = Math.sin(wink), nx = -uy, ny = ux;
    var tx = x + ux * len, ty = y + uy * len;
    c.beginPath(); c.moveTo(x, y);
    c.bezierCurveTo(x + ux * len * 0.25 + nx * breit * 1.25, y + uy * len * 0.25 + ny * breit * 1.25,
                    x + ux * len * 0.85 + nx * breit * 0.55, y + uy * len * 0.85 + ny * breit * 0.55, tx, ty);
    c.bezierCurveTo(x + ux * len * 0.8 - nx * breit * 0.7, y + uy * len * 0.8 - ny * breit * 0.7,
                    x + ux * len * 0.25 - nx * breit * 0.9, y + uy * len * 0.25 - ny * breit * 0.9, x, y);
    c.fill();
  }
  function stiel(c, x0, y0, x1, y1, bieg, dicke) {
    c.lineWidth = dicke; c.lineCap = 'round'; c.beginPath(); c.moveTo(x0, y0);
    c.quadraticCurveTo((x0 + x1) / 2 + bieg, (y0 + y1) / 2, x1, y1); c.stroke();
  }

  function start(el) {
    if (el.__ode) return; el.__ode = true;
    var d = el.dataset, band = d.modus === 'band', motiv = d.motiv === 'frucht' ? 'frucht' : 'blatt';
    var en = document.documentElement.lang === 'en';
    var ziel = berlin(d.datum, d.zeit);
    var namen = en ? ['DAYS', 'HOURS', 'MINUTES'] : ['TAGE', 'STUNDEN', 'MINUTEN'];
    var uhr = el.querySelector('[data-ode-neu-uhr]');
    var felder = uhr ? uhr.querySelectorAll('[data-wert]') : [];
    function htmlUhr() {
      var r = rest(ziel);
      if (felder.length >= 3) { felder[0].textContent = r.t; felder[1].textContent = zw(r.h); felder[2].textContent = zw(r.m); }
      if (uhr) uhr.setAttribute('aria-label', (en ? 'Still ' : 'Noch ') + r.t + (en ? ' days, ' : ' Tage, ') + r.h + (en ? ' hours' : ' Stunden'));
    }
    htmlUhr(); setInterval(htmlUhr, 15000);

    var cv = el.querySelector('canvas'), c = cv && cv.getContext && cv.getContext('2d');
    if (!c || isNaN(ziel)) return;
    var fam = (getComputedStyle(document.body).getPropertyValue('--font-heading--family') || 'sans-serif').trim();
    var font = function (px) { return '700 ' + px + 'px ' + fam; };

    function hoch() { return cv.clientWidth < cv.clientHeight * 0.9; }
    /* Countdown: Mitte x, Breite, Mitte y (von oben). Motiv: Ansatzpunkt und Größe. */
    function lay() {
      var hh = hoch();
      if (band) return hh
        ? { uhr: [0.5, 0.88, 0.24], fr: { x: 0.5, y: 1.0, r: 0.72, rw: true }, bl: { x: 0.66, y: 0.66, s: 0.6, rw: true } }
        : { uhr: [0.36, 0.58, 0.34], fr: { x: 0.8, y: 1.12, r: 0.82, rw: false }, bl: { x: 0.78, y: 0.92, s: 0.64, rw: false } };
      return hh
        ? { uhr: [0.5, 0.92, motiv === 'frucht' ? 0.74 : 0.66], fr: { x: 0.5, y: 0.94, r: 0.8, rw: true }, bl: { x: 0.38, y: 0.44, s: 0.72, rw: true } }
        : { uhr: [0.5, 0.8, 0.62], fr: { x: 0.5, y: 1.16, r: 0.86, rw: false }, bl: { x: 0.3, y: 0.44, s: 0.6, rw: false } };
    }

    /* Auftritt: Grapefruit und Zahlen gleiten von unten herein und blenden auf.
       t0 = Zeitpunkt, an dem das Plakat wirklich sichtbar wird. Wechselt eine Zahl, gleitet sie neu herein. */
    var t0 = -1, alt = ['', '', ''], seit = [0, 0, 0];
    /* Spielerei: Antippen (Seite) lässt die Grapefruit wackeln; Scrollen bringt das Blatt zum Schwingen */
    var tipp = -1, schw = 0, schwV = 0, letztY = window.scrollY;
    window.addEventListener('scroll', function () {
      var dy = window.scrollY - letztY; letztY = window.scrollY;
      if (!ruhig()) { schwV += Math.max(-0.06, Math.min(0.06, dy * 0.0012)); los(); }
    }, { passive: true });
    if (!band) (el.querySelector('[data-ode-neu-feld]') || el).addEventListener('pointerdown', function (e) {
      if (e.target.closest('a, button, input, form')) return;
      tipp = performance.now(); schwV += 0.08; los();
    });
    var ease = function (p) { p = Math.max(0, Math.min(1, p)); return 1 - Math.pow(1 - p, 3); };
    function auftritt(jetzt, verz, dauer) { if (ruhig()) return 1; if (t0 < 0) return 0; return ease((jetzt - t0 - verz) / dauer); }

    function zeichne(zeit) {
      var w = cv.width, h = cv.height, L = lay(), ru = ruhig();
      schwV += -schw * 0.03; schwV *= 0.93; schw += schwV;
      if (Math.abs(schw) < 0.0005 && Math.abs(schwV) < 0.0005) { schw = 0; schwV = 0; }
      var wk = (tipp >= 0 && !ru) ? (zeit - tipp) / 1000 : 99;
      var wob = wk < 2.5 ? Math.sin(wk * 16) * Math.exp(-wk * 2.6) : 0;
      var sway = ru ? 0 : Math.sin(zeit / 1000 * 0.7) * 0.025 + schw + wob * 0.25;
      c.globalAlpha = 1; c.fillStyle = GRUEN; c.fillRect(0, 0, w, h);
      c.fillStyle = BLATT; c.strokeStyle = BLATT;
      var pm = auftritt(zeit, 0, 1400);
      var obst = null;
      c.globalAlpha = band ? pm : 1; /* Seite: Frucht nur gleiten lassen, damit der Übergang nach unten rosa bleibt */
      if (motiv === 'frucht') {
        var f = L.fr, ry = (f.rw ? f.r * w : f.r * h) * (1 - wob * 0.05), rx = ry * 1.05 * (1 + wob * 0.1), cx = f.x * w, cy = f.y * h + (1 - pm) * ry * 0.35;
        /* Seite: Kugel so breit, dass der untere Rand der Bühne ganz rosa ist */
        if (!band) { var ub = (cy - h) / ry; rx = Math.max(rx, 0.53 * w / Math.sqrt(Math.max(0.05, 1 - ub * ub))); }
        c.fillStyle = FRUCHT; c.beginPath(); c.ellipse(cx, cy, rx, ry, 0, 0, Math.PI * 2); c.fill();
        obst = [cx, cy, rx, ry];
        var a = -0.28, sx = cx + Math.sin(a) * rx, sy = cy - Math.cos(a) * ry, st = ry * 0.14;
        var ex = sx - st * 0.42, ey = sy - st;
        c.fillStyle = BLATT; c.strokeStyle = BLATT;
        stiel(c, sx, sy + 4, ex, ey, -st * 0.15, Math.max(3, ry * 0.032));
        blatt(c, ex, ey, -0.6 + sway, ry * 0.56, ry * 0.3);
      } else {
        /* Nur Blatt: Stiel mit zwei großen Blättern, wie oben auf dem Lemon-Motiv */
        var b = L.bl, gs = (b.rw ? w : h) * b.s, bx = b.x * w, by = b.y * h + (1 - pm) * gs * 0.3;
        var kx = bx + gs * 0.06, ky = by - gs * 0.34;
        stiel(c, bx, by, kx, ky, -gs * 0.08, Math.max(3, gs * 0.035));
        blatt(c, kx, ky, -2.2 + sway, gs * 0.95, gs * 0.36);
        blatt(c, kx, ky, -0.35 - sway * 0.8, gs * 0.78, gs * 0.3);
      }
      /* Countdown: Ziffern eng nach ihrer sichtbaren Form gesetzt (eine 1 ist schmaler als eine 0) */
      var r = rest(ziel), gruppen = [String(r.t), zw(r.h), zw(r.m)];
      gruppen.forEach(function (g, i) { if (g !== alt[i]) { if (alt[i] && t0 >= 0) seit[i] = zeit; alt[i] = g; } });
      c.font = font(100);
      /* Eng: Ziffern fast Kante an Kante, schmaler Doppelpunkt. Größe nach der Breite einer 0, damit nichts springt. */
      c.textAlign = 'left';
      var m0 = c.measureText('0'), null100 = (m0.actualBoundingBoxLeft || 0) + (m0.actualBoundingBoxRight || m0.width);
      var dp = 24, GAP = 0.012;
      var b100 = gruppen.reduce(function (s, g, j) { return s + g.length * null100 + (g.length - 1) * GAP * 100 + (j ? dp : 0); }, 0);
      var F = Math.min(L.uhr[1] * w / b100 * 100, h * (hoch() ? 0.24 : (band ? 0.28 : 0.36)));
      c.font = font(F); c.textAlign = 'left';
      var luft = F * GAP;
      var formen = gruppen.map(function (g) {
        var z = [], breite = 0;
        for (var j = 0; j < g.length; j++) {
          var m = c.measureText(g[j]), li = m.actualBoundingBoxLeft || 0, re = m.actualBoundingBoxRight || m.width;
          z.push({ ch: g[j], li: li, b: li + re }); breite += li + re + (j ? luft : 0);
        }
        return { z: z, b: breite };
      });
      var gesamt = formen.reduce(function (s, fo, j) { return s + fo.b + (j ? dp * F / 100 : 0); }, 0);
      var y = h * L.uhr[2], x0 = L.uhr[0] * w - gesamt / 2, hub = F * 0.32;
      /* Zahlen in Rosa; wo sie über der Grapefruit liegen, in Dunkelgrün (wie ausgeschnitten) */
      function malen(farbe) {
        var x = x0;
        c.textBaseline = 'middle'; c.fillStyle = farbe;
        formen.forEach(function (fo, i) {
          if (i) {
            var pd = auftritt(zeit, 350 + i * 220, 900);
            c.globalAlpha = pd; c.textAlign = 'center';
            var px = x + dp * 0.5 * F / 100, rr = F * 0.05;
            [-0.16, 0.16].forEach(function (o) { c.beginPath(); c.arc(px, y + F * o, rr, 0, Math.PI * 2); c.fill(); });
            x += dp * F / 100;
          }
          var p = auftritt(zeit, 300 + i * 260, 1000);
          if (seit[i] && !ru) p = Math.min(p, ease((zeit - seit[i]) / 700));
          var dy = (1 - p) * hub;
          c.globalAlpha = p; c.font = font(F); c.textAlign = 'left';
          var cx2 = x;
          fo.z.forEach(function (z, j) { if (j) cx2 += luft; c.fillText(z.ch, cx2 + z.li, y + dy); cx2 += z.b; });
          c.font = '700 ' + Math.max(11, F * 0.11) + 'px ' + fam; c.textAlign = 'center';
          c.globalAlpha = auftritt(zeit, 300 + i * 260, 1000);
          c.fillText(namen[i], x + fo.b / 2, y + F * 0.56);
          x += fo.b;
        });
      }
      malen(ROSA);
      if (obst) {
        c.save(); c.beginPath(); c.ellipse(obst[0], obst[1], obst[2], obst[3], 0, 0, Math.PI * 2); c.clip();
        malen(BLATT); c.restore();
      }
      c.globalAlpha = 1;
    }

    function groesse() {
      var rr = cv.getBoundingClientRect(), dpr = Math.min(window.devicePixelRatio || 1, 2);
      var w = Math.round(rr.width * dpr), h = Math.round(rr.height * dpr);
      if (w && h && (cv.width !== w || cv.height !== h)) { cv.width = w; cv.height = h; }
      /* Band hochkant: der Text liegt auf der Grapefruit, also dunkle Schrift (CSS-Klasse) */
      el.classList.toggle('auf-frucht', band && motiv === 'frucht' && hoch());
    }

    var sichtbar = true, laeuft = false, letzteMinute = -1;
    function schritt(t) {
      laeuft = false;
      if (!sichtbar) return;
      zeichne(t);
      if (!ruhig()) { laeuft = true; requestAnimationFrame(schritt); }
    }
    function los() { if (!laeuft && sichtbar) { laeuft = true; requestAnimationFrame(schritt); } }

    var bereit = document.fonts && document.fonts.load ? document.fonts.load(font(100), '0123456789').catch(function () {}) : Promise.resolve();
    bereit.then(function () {
      groesse(); zeichne(performance.now());
      el.classList.add('ist-live');
      los();
      /* Bei ruhiger Darstellung jede Minute neu zeichnen */
      setInterval(function () { var m = new Date().getMinutes(); if (sichtbar && ruhig() && m !== letzteMinute) { letzteMinute = m; zeichne(performance.now()); } }, 5000);
      if ('ResizeObserver' in window) new ResizeObserver(function () { groesse(); zeichne(performance.now()); }).observe(cv);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (e) { sichtbar = e[0].isIntersecting; if (sichtbar) los(); }).observe(el);
        var io2 = new IntersectionObserver(function (e) { if (e[0].isIntersecting) { t0 = performance.now(); io2.disconnect(); los(); } }, { threshold: 0.35 });
        io2.observe(cv);
      } else { t0 = performance.now(); }
    });
  }

  function alle() {
    var els = document.querySelectorAll('[data-ode-neu]');
    if (!('IntersectionObserver' in window)) { els.forEach(start); return; }
    var io = new IntersectionObserver(function (e) {
      e.forEach(function (x) { if (x.isIntersecting) { io.unobserve(x.target); start(x.target); } });
    }, { rootMargin: '400px' });
    els.forEach(function (el) { io.observe(el); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alle); else alle();
})();
